import { sortBy } from 'lodash';
import React from 'react';
import { UncontrolledPopover } from 'reactstrap';

type Props = {
  facilities: { name: string; icon: string }[] | undefined;
};
const DISPLAY_ITEM_NUMBER = 5;
export default function FacilityList({ facilities }: Props) {
  const ref = React.useRef<any>();
  const [items, popupItems] = React.useMemo(() => {
    let faOrdered = sortBy(facilities, x => x.name.length);
    return [faOrdered.filter((_, index) => index < DISPLAY_ITEM_NUMBER), faOrdered.filter((_, index) => index >= DISPLAY_ITEM_NUMBER)];
  }, [facilities]);
  return (
    <>
      {items?.map(f => {
        return (
          <div className="col-auto" key={f.name}>
            <div className="border-light rounded-100 py-5 px-20 text-14 lh-14">
              <i className={`${f.icon} ficon text-16 pr-5`}></i>
              {f.name}
            </div>
          </div>
        );
      })}
      {popupItems?.length ? (
        <>
          <div className="col-auto">
            <button ref={ref} className="text-white fw-500 bg-blue-1 rounded-100 py-5 px-20 text-14 lh-14">
              {`${popupItems.length}+`}
            </button>
          </div>
          <UncontrolledPopover className="shadow transition-cubic" target={ref} trigger="focus" placement="top">
            <div className="px-20 py-20">
              <div className="row x-gap-10 y-gap-10">
                {popupItems?.map(f => {
                  return (
                    <div className="col-auto" key={f.name}>
                      <div className="border-light rounded-100 py-5 px-20 text-14 lh-14">
                        <i className={`${f.icon} ficon text-16 pr-5`}></i>
                        {f.name}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </UncontrolledPopover>
        </>
      ) : null}
    </>
  );
}
